import $ from 'jquery';
import { buildForm } from '../forms';

$(function() {
    buildForm(document);
});